import tabs from './tabs.js'
import tabPane from './tab-pane.js'
export default { tabs, tabPane }
